module.exports = __webpack_public_path__ + "static/media/icon-score-4-scale-5.916d3efb.svg";